import { api } from '@/lib/api';
import type { LoRaDevice, CalibrationRequest, CalibrationResponse } from './types';

export async function getLoRaDevices(): Promise<LoRaDevice[]> {
  return api.get<LoRaDevice[]>('/v4/lorawancalibration/');
}

export async function sendCalibration(req: CalibrationRequest): Promise<CalibrationResponse> {
  return api.post<CalibrationResponse>('/v4/lorawancalibration/calibrate', req);
}
